import './follow-us.component.scss'

import Swiper, { Grid, Autoplay } from 'swiper'

import 'swiper/css'
import 'swiper/css/grid'
import 'swiper/css/autoplay'

const followUs = document.querySelector('.follow-us')
if (followUs) {
  const followGal = followUs.querySelector('.follow-gal')
  new Swiper(followGal, {
    modules: [ Grid, Autoplay ],
    autoplay: {
      delay: 3000
    },
    slidesPerView: 1,
    grid: {
      fill: 'row',
      rows: 2,
    },
    spaceBetween: 16,
    breakpoints: {
      375: {
        slidesPerView: 2,
        grid: {
          rows: 2,
        }
      },
      667: {
        slidesPerView: 3,
        grid: {
          rows: 2,
        }
      },
      1024: {
        slidesPerView: 4,
        grid: {
          rows: 2,
        }
      },
      1440: {
        slidesPerView: 5,
        grid: {
          rows: 2,
        }
      }
    }
  })
}